/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { TransactionAcquisitionPagedList } from '../../models/transaction-acquisition-paged-list';
import { TransactionAcquisitionSearchBody } from '../../models/transaction-acquisition-search-body';
import { TransactionAcquisitionSortFieldName } from '../../models/transaction-acquisition-sort-field-name';

export interface SearchTransactionAcquisition$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * CONNECTION_NAME : the station's name
 *   * MODIFICATION_DATE : the creation's date
 *   * STATE : the item's state
 */
  sortFieldName?: TransactionAcquisitionSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search transaction acquisition
     */
    body?: TransactionAcquisitionSearchBody
}

export function searchTransactionAcquisition$Json(http: HttpClient, rootUrl: string, params?: SearchTransactionAcquisition$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionAcquisitionPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchTransactionAcquisition$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionAcquisitionPagedList>;
    })
  );
}

searchTransactionAcquisition$Json.PATH = '/custom/stations/transaction-acquisition/search';
